import classNames from 'classnames'
import React, { useContext } from 'react'
import IconEye from '../../assets/iconEye.svg'
import BGModal from '../../assets/modalBG.svg'
import transferBeneficiaryContext from 'contexts/transferBeneficiaryContext'

interface Props{
  isClose: (val:boolean)=>void
  isConfirme: any,
  setNumStep: any
}

const ModaleWallet: React.FC <Props> = ({isClose, isConfirme, setNumStep,}) => {
  const {TransferData}= useContext(transferBeneficiaryContext)

  return (
    
     <div className={classNames('fixed justify-center  items-center flex flex-col inset-0 z-20 bg-[#6C69EB99] backdrop-blur-sm h-screen transition-transform overflow-y-scroll  ' , )} >
            <img
                className={` rounded-full shadow-xl  -mb-[30px]`}
                width={88}
                height={88}
                src={IconEye}
              />
          <img src={BGModal} width={327} height={78} alt=''/>

           <div className='w-[327px] rounded-b-[16px]  flex flex-col items-center px-5 space-y-10 2xl:space-y-4 sm:px-5 bg-white '>
              <h2 className='text-[#1D3A70] font-semibold text-[24px] '>Confirmation</h2>
              
              <div className='flex items-center  w-full text-[18px] justify-between border-b  '>
                <div className='text-[#6B7280] '>Bénéficiaire</div>
                <div className='text-[#1D3A70] font-semibold '>{TransferData?.BeneficiaryName}</div>
              </div>

              <div className='flex items-center   w-full text-[18px] justify-between border-b '>
                <div className='text-[#6B7280] '>Numéro</div>
                <div className='text-[#1D3A70] font-semibold '> + {TransferData?.phoneNumberBeneficiary} </div>
              </div>

              <div className='flex items-center  w-full text-[18px] justify-between border-b '>
                <div className='text-[#6B7280] '>Montant envoyé</div>
                <div className='text-[#1D3A70] font-semibold '>{TransferData?.euroValue} EUR </div>
              </div>
              
              <div className='flex items-center  w-full text-[18px] justify-between border-b '>
                <div className='text-[#6B7280] '>Montant à recevoir</div>
                <div className='text-[#1D3A70] font-semibold '>{TransferData?.amountToReceive} {TransferData?.valuePays} </div>
              </div> 

              <div className='flex flex-col items-center'>
                <h3 className='text-[#4743C9] font-bold text-[18px]'>Attention !</h3>
                <p className='text-[#4743C9] text-[12px] text-center'>
                  Avant de procéder au paiement, veuillez vérifier le numéro de votre bénéficiaire.
                  Une fois cette étape validée, il ne sera plus possible de revenir en arrière.
                </p> 
              </div>

              <div className='flex justify-center gap-10 items-center w-full pb-4'>
                <button className='rounded-xl border h-[48px] w-[140px] text-[#5754E5]  border-[#5754E5]'
                  onClick={()=>isClose(false)}
                >
                  Retour
                </button>
                <button className='rounded-xl border h-[48px] w-[140px] bg-[#5754E5] text-white'
                  onClick={()=>{isConfirme('2'),setNumStep(2), isClose(false)}}
                >
                  Confirmer
                </button>

              </div>
            </div>
          
    </div>
  )
}

export default ModaleWallet
